import pickupDropoff from "./pickupDropoff.component";

const pickupDropoffModule = angular
  .module("app.components.pickupDropoff", [])
  .component("pickupDropoff", pickupDropoff);

export default pickupDropoffModule;



// WEBPACK FOOTER //
// ./src/components/pickupDropoff/pickupDropoff.module.js